import { Upload } from "lucide-react"
import { useState } from "react"

import { UploadDocumentsModal } from "@/components/modals/UploadDocumentsModal"
import { Button } from "@ui/button"

import { ContentObjectItem } from "@vertesia/common"

interface UploadDocumentsButtonProps {
    collectionId?: string | undefined
    light?: boolean
    skip?: boolean
    onUploadDone: (documents: ContentObjectItem[]) => void
}
export function UploadDocumentsButton({ collectionId, light = false, skip = false, onUploadDone }: Readonly<UploadDocumentsButtonProps>) {
    const [open, setOpen] = useState(false)

    const handleOnUploadDone = (documents: ContentObjectItem[]) => {
        onUploadDone(documents)
    }

    return (
        <>
            <Button onClick={() => setOpen(true)} variant={`${light ? "outline" : "default"}`} className={`${light ? "text-gray-900 border-gray-900" : ""}`}>
                <Upload />
                <span>Upload Document(s)</span>
            </Button>
            <UploadDocumentsModal open={open} onOpenChange={setOpen} onUploadDone={handleOnUploadDone} collectionId={collectionId} addSkipped={skip} />
        </>
    )
}